import { Link } from "react-router-dom";
import { ArrowUpRight, CheckCircle2, HelpCircle } from "lucide-react";
import PaymentDetailsCard from "../components/payments/PaymentDetailsCard";
import PaymentResultShell from "../components/payments/PaymentResultShell";
import { usePaymentVerification } from "../hooks/usePaymentVerification";

function ActionButton({ to, primary, children }) {
    return (
        <Link
            to={to}
            className={
                primary
                    ? "inline-flex items-center justify-center gap-2 text-sm font-semibold text-black bg-gradient-to-r from-cyan-300 to-emerald-400 hover:opacity-90 px-6 py-3 rounded-full transition w-full sm:w-auto"
                    : "inline-flex items-center justify-center gap-2 text-sm font-medium text-zinc-300 hover:text-white border border-white/10 hover:bg-white/5 px-6 py-3 rounded-full transition w-full sm:w-auto"
            }
        >
            {children}
        </Link>
    );
}

export default function PaymentSuccessPage() {
    const { loading, data, error, succeeded } = usePaymentVerification("success");

    if (loading) {
        return (
            <PaymentResultShell
                testId="payment-success-page"
                loading
                loadingText="Confirming your payment…"
            />
        );
    }

    if (succeeded) {
        return (
            <PaymentResultShell
                testId="payment-success-page"
                tone="success"
                badge="Payment confirmed"
                icon={<CheckCircle2 className="w-8 h-8 text-emerald-400" />}
                title="You're all set"
                description="Thank you. Your ApexBrain subscription is being provisioned — check your inbox for onboarding steps."
                actions={
                    <>
                        <ActionButton to="/" primary>
                            Go to home
                            <ArrowUpRight className="w-4 h-4" />
                        </ActionButton>
                        <ActionButton to="/help">
                            <HelpCircle className="w-4 h-4" />
                            Get help
                        </ActionButton>
                    </>
                }
            >
                <PaymentDetailsCard data={data} />
            </PaymentResultShell>
        );
    }

    return (
        <PaymentResultShell
            testId="payment-success-page"
            tone="error"
            badge="Verification issue"
            icon={<CheckCircle2 className="w-8 h-8 text-amber-400" />}
            title="Payment not confirmed"
            description={
                error ??
                "We could not verify this payment as successful. If you were charged, contact support with your payment ID."
            }
            actions={
                <>
                    <ActionButton to="/pricing" primary>
                        Back to pricing
                        <ArrowUpRight className="w-4 h-4" />
                    </ActionButton>
                    <ActionButton to="/help">Contact support</ActionButton>
                </>
            }
        >
            {data && <PaymentDetailsCard data={data} />}
        </PaymentResultShell>
    );
}
